import * as CONSTANTS from '../constants.js'
import api from '@/api'
import moment from 'moment'
//import router from '../router'
import util from '../util'

export default {
  createAlert: function (code, msg, contextClass) {
    
    if (!contextClass) {
      contextClass = CONSTANTS.ALERT_CONTEXT.DANGER
    }
    return {
      code: code,
      msg: msg,
      contextClass: contextClass,
      active: true
    }
  },
  stringIsBlank(str) {
    return (!str || /^\s*$/.test(str));
  },
  orderSortComparator (a, b) {
    if (a.order < b.order) { 
      return -1 
    }
    if (a.order > b.order) { 
      return 1 
    }
    return 0
  },
  accessStateSort(x, y, col, rowX, rowY) {    
    
    if (rowX.access.last_accessed 
        && !/^\s*$/.test(rowX.access.last_accessed)){
      x = 'zzz'+rowX.access.last_accessed
    } else if (rowX.access.state === 'unknown') {
      x = 'aaa'+rowX.access.state 
    } else {
      x = 'bbb'+rowX.access.state 
    }
    if ( rowY.access.last_accessed
      && !/^\s*$/.test(rowY.access.last_accessed ) ){
      y = 'zzz'+rowY.access.last_accessed
    } else if (rowY.access.state === 'unknown') {
      y = 'aaa'+rowY.access.state 
    } else {
      y ='bbb'+rowY.access.state
    }
    
    return (x < y ? -1  : (x > y ? 1 : 0));
  },
  entitlementSort(x, y, col, rowX, rowY) { 
    
    x = util.parseEntitlementString(x)
    y = util.parseEntitlementString(y)

    if(x === '-') {
      x = 'zzz'
    }
    if(y === '-') {
      y = 'zzz'
    }

    if (x) {
      x = x.replace(/<[^>]*>?/gm, '').toLowerCase()
    }
    if (y) {
      y = y.replace(/<[^>]*>?/gm, '').toLowerCase()
    }    
    return (x < y ? -1  : (x > y ? 1 : 0));
  },
  favoriteSort(x, y, col, rowX, rowY) {    
    return (rowX.isFavorite < rowY.isFavorite ? -1  : (rowX.isFavorite >rowY.isFavorite ? 1 : 0));
  },
  truncate(text,stop,clamp) {
    if (!text) {
      return text
    }
    return text.slice(0, stop) + (stop < text.length ? clamp || '...' : '')
  },
  formatRouteName(name) {
    if (!name) {
      return name
    }
    var ret = name.toLowerCase()
    return ret.split(' ').join('-')
  },
  postActionClick(app, userName, route, reference, action) {
    
    let actionData = {
      "app_id":app.id,
      "userName": userName,      
      "view": route,
      "action" : action,
      "reference" : reference
    }
    
    api.postAction(actionData).catch(e => {
      console.error("Actions API POST error", app.id, route)
    })
    
  },
  timestampToDate(timestamp) {
    let current = moment().unix()
    if(timestamp > current) {
        timestamp = timestamp/1000
    }
    let time = moment.unix(timestamp)
    return time.format("YYYY-MM-DD")
  },
  parseEntitlementString(str) {
    if (str === "unknown") {
      return "-";
    } else if (str === "fte") {
      return "All FTE";
    } else if (str === "all") {
      return "All workers";
    } else if (str === 'no-access') {
      return "No access"
    } else if (str === 'no-access-source-system') {
      return "Source System"
    }else {
      return str;
    }
  }
}
